<template>
  <layout-full>
    <keep-alive :include="['MemberLearningList']">
    <router-view />
    </keep-alive>
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'

export default {
  components: {
    LayoutFull,
  },
}
</script>
